import {apiVoissa} from "../../libs/api";


export const reportStatus = (statusId, data = {}) => apiVoissa.post(`/status/${statusId}/reporting`, data);